<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("unit.title", 1) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="unitFilter"
          :options="unitOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:unitFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">REMS</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="remsFilter"
          :options="remsOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:remsFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">SIRH</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sirhFilter"
          :options="sirhOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:sirhFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">División</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sectorFilter"
          :options="sectorOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:sectorFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">Categoría</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="categoryFilter"
          :options="categoryOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:categoryFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">Número de pisos</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="numberFloorsFilter"
          :options="numberFloorsOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:numberFloorsFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">Estatus</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="statusFilter"
          :options="statusOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:statusFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>Fecha creación</label>
        <flat-pickr
          :value="createdAtFilter"
          class="form-control"
          @input="(val) => $emit('update:createdAtFilter', val)"
          :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label>Fecha actualización</label>
        <flat-pickr
          :value="updatedAtFilter"
          class="form-control"
          @input="(val) => $emit('update:updatedAtFilter', val)"
          :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">SOEID</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="brigadeUsersFilter"
          :options="brigadeUsersOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:brigadeUsersFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    flatPickr,
  },
  props: {
    unitOptions: {
      type: Array,
      default: null,
    },
    unitFilter: {
      type: Array,
      default: null,
    },
    sectorOptions: {
      type: Array,
      default: null,
    },
    sectorFilter: {
      type: Array,
      default: null,
    },
    remsOptions: {
      type: Array,
      default: null,
    },
    remsFilter: {
      type: Array,
      default: null,
    },
    sirhOptions: {
      type: Array,
      default: null,
    },
    sirhFilter: {
      type: Array,
      default: null,
    },
    categoryOptions: {
      type: Array,
      default: null,
    },
    categoryFilter: {
      type: Array,
      default: null,
    },
    numberFloorsOptions: {
      type: Array,
      default: null,
    },
    numberFloorsFilter: {
      type: Array,
      default: null,
    },
    statusOptions: {
      type: Array,
      default: null,
    },
    statusFilter: {
      type: Array,
      default: null,
    },
    createdAtFilter: {
      type: String,
      default: null,
    },
    updatedAtFilter: {
      type: String,
      default: null,
    },
    brigadeUsersFilter: {
      type: [Array, Number],
      default: null,
    },
    brigadeUsersOptions: {
      type: Array,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
